import React from "react";

import ReactCountryFlag from "react-country-flag";
import "../css/SemanasInternacionales.css";

const SemanasInternacionales = () => {
  return (
    <section className="lightbluebg  semanas-container padding">
      <h2 className="titulo">🌍 Semanas <b> Internacionales</b></h2>
      <p className="subtitulo">Elige tu destino y conviértelo en una experiencia que va más allá del aula 🚀</p>

      <div className="cards ">
        {/* Medellín */}
        <div className="card">
          <img
            src="https://www.utpl.edu.ec/maestrias/sites/default/files/eafit.png"
            alt="Medellín Colombia"
            className="imagen"
          />
          <div className="contenido">
            <h3 className="titulo-card">
              <ReactCountryFlag
                countryCode="CO"
                svg
                style={{ width: "1.5em", height: "1.5em", marginRight: "8px" }}
              />
              EAFIT – Medellín
            </h3>
            <p>
              Vive una semana en una ciudad llena de innovación. Conecta con
              empresas reales, descubre nuevas ideas y abre tu mente a una
              experiencia global.
            </p>
          </div>
        </div>

        {/* Valencia */}
        <div className="card">
          <img
            src="https://www.utpl.edu.ec/maestrias/sites/default/files/edem.png"
            alt="Valencia España"
            className="imagen"
          />
          <div className="contenido">
            <h3 className="titulo-card">
              <ReactCountryFlag
                countryCode="ES"
                svg
                style={{ width: "1.5em", height: "1.5em", marginRight: "8px" }}
              />
              EDEM – Valencia
            </h3>
            <p>
              Aprende marketing digital e inteligencia artificial con casos
              reales, mientras disfrutas una experiencia cultural única en
              Valencia.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SemanasInternacionales;
